import styled, { css } from 'styled-components';
import { getSpace } from '../../../foundation/theme/space.utils';
import { MAP_CELL_STYLES } from './BaseTable.constants';
// styled-components.
// -----------------------------------------------------------------------------
export const BaseTableTDRoot = styled.td `
  ${({ align, size, type }) => {
    const { paddingX, paddingY } = MAP_CELL_STYLES[size][type];
    return css `
      // Box.
      text-align: ${align};

      // Scacing
      padding-bottom: ${getSpace(paddingY)};
      padding-left: ${getSpace(paddingX)};
      padding-right: ${getSpace(paddingX)};
      padding-top: ${getSpace(paddingY)};
    `;
}}
`;
//# sourceMappingURL=BaseTableTD.styled.js.map